export function getEntriesWithKeys<T>(
  items: readonly T[],
  getSemanticKey: (item: T) => string,
): Array<{ key: string; item: T }> {
  const keyOccurrences = new Map<string, number>()

  return items.map((item) => {
    const semanticKey = getSemanticKey(item)
    const occurrence = (keyOccurrences.get(semanticKey) ?? 0) + 1
    keyOccurrences.set(semanticKey, occurrence)

    return { key: `${semanticKey}:${occurrence}`, item }
  })
}
